import { Alert, Modal, Typography } from "antd";

import type { ImportSummary } from "../api/resources";

export function ImportResultModal({
  result,
  onClose,
}: {
  result: ImportSummary | null;
  onClose: () => void;
}) {
  return (
    <Modal open={!!result} title="导入结果" onCancel={onClose} onOk={onClose} okText="知道了" cancelButtonProps={{ style: { display: "none" } }}>
      {result && (
        <>
          <Typography.Paragraph>
            共 {result.totalRows} 行 / 新增 {result.inserted} / 更新 {result.updated} / 跳过{" "}
            {result.skipped}
          </Typography.Paragraph>
          {result.errors.length > 0 && (
            <Alert
              type="warning"
              showIcon
              message={`${result.errors.length} 条错误`}
              description={
                <ul style={{ margin: 0, paddingLeft: 16, maxHeight: 200, overflow: "auto" }}>
                  {result.errors.slice(0, 50).map((e, i) => (
                    <li key={i}>
                      行 {e.row}: {e.reason}
                    </li>
                  ))}
                </ul>
              }
            />
          )}
        </>
      )}
    </Modal>
  );
}
